import { patientIdSchema } from "@repo/api/schemas";
import { usePerformanceMeasureScores, usePerformanceMeasures } from "@repo/data-store";
import { createFileRoute } from "@tanstack/react-router";
import { PerformanceMeasureDetail } from "@/features/assessments";

export const Route = createFileRoute("/patients/$patientId/_layout/assessments/m/$measureId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { measureId } = Route.useParams();
  const patientId = patientIdSchema.parse(Route.useParams().patientId);
  const measures = usePerformanceMeasures({ patientId });
  const scores = usePerformanceMeasureScores(patientId);
  const measure = measures.find((candidate) => candidate.id === measureId);

  if (!measure) {
    return <div className="p-6 text-sm text-muted-foreground">Performance measure not found.</div>;
  }

  return <PerformanceMeasureDetail measure={measure} scores={scores} measures={measures} />;
}
